"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _marketing = require("@/api/marketing");
var _permission = require("@/utils/permission");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
// 权限判断函数
var _default = exports.default = {
  name: 'videoList',
  data: function data() {
    return {
      listLoading: false,
      tableData: {
        data: [],
        total: 0
      },
      tableFrom: {
        page: 1,
        limit: this.$constants.page.limit[0],
        proId: '',
        search: ''
      },
      search: ''
    };
  },
  mounted: function mounted() {
    if ((0, _permission.checkPermi)(['merchant:pay:component:product:draft:list'])) this.getList();
  },
  methods: {
    checkPermi: _permission.checkPermi,
    /**
     * 删除
     * @param rowData
     */
    handlerOpenDel: function handlerOpenDel(rowData) {
      var _this = this;
      this.$modalSure('删除当前数据').then(function () {
        (0, _marketing.draftDelApi)(rowData.id).then(function (data) {
          _this.$message.success('删除数据成功');
          _this.getList();
        });
      });
    },
    /**
     * 提审 platformStatus：2提审，1撤回
     */
    handlerReview: function handlerReview(rowData, num) {
      var _this2 = this;
      this.$modalSure(num === 2 ? '提审商品至平台吗？' : '撤回申请吗？').then(function () {
        (0, _marketing.draftReviewApi)({
          draftProductId: rowData.id,
          platformEditStatus: num
        }).then(function (data) {
          _this2.$message.success('提交成功');
          _this2.getList();
        });
      });
    },
    /**
     * 列表
     * @param num
     */
    getList: function getList(num) {
      var _this3 = this;
      this.listLoading = true;
      this.tableFrom.page = num ? num : this.tableFrom.page;
      this.tableFrom.search = encodeURIComponent(this.search);
      (0, _marketing.draftListApi)(this.tableFrom).then(function (res) {
        _this3.tableData.data = res.list;
        _this3.tableData.total = res.total;
        _this3.listLoading = false;
      }).catch(function (res) {
        _this3.listLoading = false;
      });
    },
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList();
    }
  }
};